import api from "shared/api";
import { ManualRaw } from "./models";
import { AxiosPromise } from "axios";

const prefix = "api/manuals";

export interface PostManualRequest {
  name: string;
  description: string;
  tags: string[] | null;
  all_relations: boolean;
  root_relation_type_ids: number[] | null;
  no_project_filter: boolean;
  project_filters: string[] | null;
  extension?: string;
}
interface PostManualResponse {
  id: number;
}
export interface RootRelationTypeResponse {
  id: number;
  description: string;
}

export const getManuals = async (): Promise<ManualRaw[]> => {
  const res = await api().get<ManualRaw[]>(`${prefix}/list`);
  return res.data;
};
export const getRootRelationTypes = async (): Promise<
  RootRelationTypeResponse[]
> => {
  const res = await api().get<RootRelationTypeResponse[]>(
    `${prefix}/root-relation-types`
  );
  return res.data;
};

export const getProjectFilterList = async (): Promise<string[]> => {
  const res = await api().get<string[]>(`${prefix}/project-filter-list`);
  return res.data;
};

export const getBlob = async (url: string): Promise<Blob> => {
  const res = await api().get<Blob>(url, { responseType: "blob" });
  return res.data;
};

export const getNonCachedBlob = async (url: string): Promise<Blob> => {
  url += "?ts=" + new Date().getTime();
  return getBlob(url);
};

export const postManual = async (
  payload: PostManualRequest
): Promise<number> => {
  const res = await api().post<PostManualResponse>(`${prefix}/new`, payload);
  return res.data.id;
};

export const postThumbnail = async (id: number, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("thumbnail", file);

  await api().post(`${prefix}/${id}/thumbnail`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const postPdf = async (id: number, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("pdf", file);

  api().post(`${prefix}/${id}/pdf`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const putManual = async (
  id: number,
  payload: PostManualRequest
): Promise<number> => {
  const res = await api().put<PostManualResponse>(`${prefix}/${id}`, payload);
  return res.data.id;
};

export const deleteManual = (id: number): AxiosPromise => {
  return api().delete(`${prefix}/${id}`);
};
